import styled from 'styled-components';

const UserWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    width: 56px;
    height: 32px;

    img {
      width: 36px;
      height: 36px;
      cursor: pointer;
      border-radius: 100px;
    }

    &:hover img{
      border: 1px solid ${(props) => props.theme.colors.text};
      transition: all .2s ease-in;
    }

    &:hover svg{
      margin-top: 16px;
      transition: all .2s ease-in;
    }
`;

const DropdownWrapper = styled.ul`
    display: flex;
    flex-direction: column;
    min-width: 300px;
    width: fit-content;
    background: ${(props) => props.theme.colors.background_dashboard};
    box-shadow: ${(props) => props.theme.shadows.dropdown};
    border-radius: 12px 0 12px 12px;;
    
    li {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 16px;  
      font-family: ManropeBold, sans-serif;
      font-size: 13px;
      cursor: pointer;
      
      &:hover {
        background: ${(props) => props.theme.colors.widget_hover_background};
      }
      
      &:first-of-type {
        display: flex;
        align-items: center;
        gap: 8px;
        border-radius: 12px 0 0 0;
        border-bottom: 1px solid ${(props) => props.theme.colors.outline};

        .avatar {
          width: 32px;
          height: 32px;

          img {
            border-radius: 100px;
          }
        }
        
        .description {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          min-height: 30px;
          height: fit-content;
          width: fit-content;
          
          p {
            white-space: nowrap;
          }

          .subtitle {
            font-family: ManropeRegular, sans-serif;
            color: ${(props) => props.theme.colors.inactive}
          }
        }
        
      }

      &.fleet-row {
        justify-content: space-between;

        .change-fleet {
          font-family: ManropeRegular, sans-serif;
          color: ${(props) => props.theme.colors.main_cta};
        }
      }

      &:last-of-type {
        border-radius: 0 0 12px 12px;
      }
    }
`;

export default { UserWrapper, DropdownWrapper };
